import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';
import Axios from 'axios';
import api from '../api';
import { wiewArquivoAnexo, downloadAnexo } from '@app/api/apiAnexo';

export interface sasFornecedorAvaliacaoFinanceira {
  id: string;
  sasFornecedorId: string;
}

export interface sasFornecedorAvaliacaoFinanceiraFrom {
  id: string;
  sasFornecedorId: string;
  arquivo: any;
  dataValidade: Date;
  comentario: string;
}

export const getAllSasFornecedorAvaliacaoFinanceira = () =>
  api.get<sasFornecedorAvaliacaoFinanceira[]>('sasFornecedorAvaliacaoFinanceira');

export const getAllSasFornecedorAvaliacaoFinanceiraByFornecedorId = (fornecedorId: string) =>
  api.get<sasFornecedorAvaliacaoFinanceira[]>(
    `sasFornecedorAvaliacaoFinanceira/getAllSasFornecedorAvaliacaoFinanceiraByFornecedorId/${fornecedorId}`,
  );

export const createSasFornecedorAvaliacaoFinanceira = (
  fornecedorAvaliacaoFinanceiraFrom: sasFornecedorAvaliacaoFinanceiraFrom,
) => {
  const form = new FormData();
  form.append('arquivo', fornecedorAvaliacaoFinanceiraFrom['arquivo']);
  form.append('sasFornecedorId', fornecedorAvaliacaoFinanceiraFrom.sasFornecedorId);
  form.append('dataValidade', fornecedorAvaliacaoFinanceiraFrom.dataValidade);
  form.append('comentario', fornecedorAvaliacaoFinanceiraFrom.comentario);

  return api.post(`sasFornecedorAvaliacaoFinanceira/createSasFornecedorAvaliacaoFinanceira`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deletesasFornecedorAvaliacaoFinanceira = (id: string) =>
  api.delete(`sasFornecedorAvaliacaoFinanceira/${id}`);

export const wiewArquivoAnexoFornecedorAvaliacaoFinanceira = async (id: string, nomeDoArquivo: string) => {
  const url = '/api/sasFornecedorAvaliacaoFinanceira/downloadAnexo';
  await wiewArquivoAnexo(id, nomeDoArquivo, url);
};

export const downloadArquivoAnexoFornecedorAvaliacaoFinanceira = async (id: any, fileName: any) => {
  const url = '/api/sasFornecedorAvaliacaoFinanceira/downloadAnexo';
  await downloadAnexo(id, fileName, url);
};
